import { Component, ContentChild, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent } from '@ionic/angular';
import { debounceTime } from 'rxjs/operators';
import { Navigator } from 'src/app/services/routing/navigator';
import { AffiliateTrackerCallbackParams } from 'src/app/interfaces/affliation-interface';
import { DepositMainLabels } from 'src/app/interfaces/deposit-main-labels';
import { BalanceModel } from 'src/app/models/balance-model';
import { DepositMainModel } from 'src/app/models/deposit-models';
import { AddressService } from 'src/app/services/address/address.service';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { WithdrawalService } from 'src/app/services/cashier/withdrawal.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { WithdrawalBaseComponent } from '../withdrawal-base/withdrawal-base.component';

@Component({
  selector: 'app-withdrawal-vip',
  templateUrl: './withdrawal-vip.component.html',
  styleUrls: ['./withdrawal-vip.component.scss'],
})
export class WithdrawalVipComponent extends WithdrawalBaseComponent implements OnInit {
  @ViewChild(IonContent, { static: false }) content: IonContent;

  public error = null;

  public withdrawalForm: FormGroup;

  public amount: AbstractControl;
  public selectedAccount: AbstractControl;
  public customerAccountID: AbstractControl;
  public currency_code: AbstractControl;
  public payment_type_code: AbstractControl;

  public accounts: any = [];
  public accountBalances: BalanceModel;
  public isPageLoaded: boolean = false;
  public vendorLogoUrl: string = '';
  public ssnValue: string;
  private paymentType: any = [];

  public disableWithdrawButton: boolean = false;
  public enterCounts = 0;
  public labels: DepositMainLabels;
  public enterPressed: boolean;

  constructor(
    public addressService: AddressService,
    public events:EventsService,
    public cashierService: CashierService,
    public cashierContentService: CashierContentService,
    public navigator:Navigator,
    public withdrawService:WithdrawalService,
    public balanceService:AccountBalanceService,
    public utils:UtilsService,
    public configService: ConfigService,
    public successMessageService: SuccessMessageService
  ) {
    super();

    this.successMessageService.clearMessage();
    this.error = null;
    this.labels = new DepositMainModel();
  }
  ngAfterViewInit(){
    this.cashierContentService.getPageConfig('vippreferred').then((response: DepositMainLabels) => {
        this.labels = response;
    });
  }

  ngOnInit() {
    this.withdrawalForm = new FormGroup(
      {
        amount: new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
        selectedAccount: new FormControl('', [Validators.required]),
        customerAccountID: new FormControl(''),
        currency_code: new FormControl(''),
        payment_type_code: new FormControl(''),
      }
    )

    this.amount = this.withdrawalForm.get('amount');
    this.selectedAccount = this.withdrawalForm.get('selectedAccount');


  }

  ionViewWillEnter() {
    this.onGetAccounts();
    this.successMessageService.clearMessage();
    this.onGetBalance();
  }

  public radioChangedCard(e) {
    console.log("hello", e.detail.value);
	}

  onGetBalance() {

    this.balanceService.getBalance().subscribe((balance: BalanceModel) => {
        if (balance) this.accountBalances = balance;
      }, error => this.error = error
    );
  
  }
  
  onAddNewAccount() {
    return this.navigator.navigateTo("DepositVipComponent", {}, { depositMethod: "ach-vip", navigateBackPage: "WithdrawalVipComponent" });
  }

  onGetAccounts() {
    this.accounts = [];
    this.cashierService.callListAccounts().subscribe((response) => {
        if (response.result) {
          var tempAccounts: any = response.payload;
          this.accounts = response.payload
            .filter(account => account.paymentTypeCode === "GP")
            .map((account, key) => {
              account.id = key;
              return account;
            });
        }
        this.isPageLoaded = true;
      }
    );
  }

  submit() {
    this.disableWithdrawButton = true;
    this.checkEnterSubmission();
  }

  checkEnterSubmission() {
    if (this.enterPressed === true) {
      if (this.enterCounts == 1) {
        setTimeout(() => { this.onWithdraw() }, 200);
      }
      this.disableWithdrawButton = false;
      this.enterPressed = false;

    } else {
      setTimeout(() => { this.onWithdraw() }, 200);
    }
  }

  onWithdraw() {
    this.disableWithdrawButton = true;
    this.successMessageService.clearMessage();
    this.error = null;

    var accountIndex: AbstractControl = this.withdrawalForm.get("selectedAccount");

    this.withdrawalForm.get("customerAccountID").setValue(this.accounts[accountIndex.value].customerAccountID);
    this.withdrawalForm.get("currency_code").setValue(this.cashierService.customer.preferredCurrency.currencyCode);
    this.withdrawalForm.get("payment_type_code").setValue("GP");


    this.withdrawService.callWithdraw(this.withdrawalForm.value).pipe(debounceTime(300)).subscribe(
      (response: any) => {
        if (response && !!response.result) {

          let depositEventData: AffiliateTrackerCallbackParams = {
            customer_id: this.cashierService.customer.customerId,
            amount: this.withdrawalForm.get('amount').value
          }
          setTimeout(() => this.events.publish('event:withdraw', depositEventData), 2000);

          this.successMessageService.setMessage('Your withdrawal request has been received.');

          this.balanceService.updateBalance();

          this.content.scrollToTop();
          this.disableWithdrawButton = false;
          this.error = null;
          this.withdrawalForm.reset();
        }
      }, (error) => {
        this.error = this.handleError(error);
        this.disableWithdrawButton = false;

      }
    )
    setTimeout(() => this.enterCounts = 0, 3000);
    this.error = null;
  }


}
